import _get from 'lodash/get'
import type { ReactElement } from 'react'
import { match } from 'ts-pattern'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import type { RichContent as RichContentProps } from '@flows/core/types/stepContentTypes'
import type { ArbitraryTypedObject, PortableTextBlock } from '@portabletext/types'

export const RichContent = (
  props: RichContentProps & {
    richContentRenderer: (richContentRendererProps: {
      blocks: (PortableTextBlock | ArbitraryTypedObject)[]
    }) => ReactElement
  }
) => {
  const servicesResponses = useFlowsServicesResponses()

  const content = match(props.source)
    .returnType<(PortableTextBlock | ArbitraryTypedObject)[]>()
    .with(
      {
        type: 'static',
      },
      (source) => source.content
    )
    .otherwise((source) => _get(servicesResponses, source.path) as PortableTextBlock[])

  return props.richContentRenderer({ blocks: content })
}
